export default __webpack_public_path__ + "static/media/adam-shaffir.0e8afc1d.png";